import { trim, addEvent } from './util_10_lang';
import { throttle } from './util_23_throttle';
var selectionHandler = {
  /**
   *  保存光标
   * @return {null}
   */
  saveSelection: function saveSelection() {
    try {
      if (typeof document !== 'undefined' && document.getSelection) {
        var sel = document.getSelection(),
            ranges = [];

        if (sel.rangeCount) {
          for (var i = 0, len = sel.rangeCount; i < len; i++) {
            ranges.push(sel.getRangeAt(i));
          }
        }

        return ranges;
      }

      if (typeof document !== 'undefined' && document.selection && document.selection.createRange) {
        return document.selection.type.toLowerCase() !== 'none' ? document.selection.createRange() : null;
      }

      return null;
    } catch (e) {
      console.log(e);
    }
  },

  /**
   * 重置光标
   * @function
   */
  restoreSelection: function () {
    if (typeof document !== 'undefined' && document.getSelection) {
      return function (savedSelection) {
        var sel = document.getSelection();
        sel.removeAllRanges();

        for (var i = 0, len = savedSelection.length; i < len; i++) {
          sel.addRange(savedSelection[i]);
        }
      };
    }

    if (typeof document !== 'undefined' && document.selection) {
      return function (savedSelection) {
        if (savedSelection) {
          savedSelection.select();
        }
      };
    }

    return function () {};
  }(),

  /**
   * 替换光标内容
   * @memberof module:dom
   * @param {string | HTMLElement} content
   * @param {string} EditorSelectorID
   * @returns {any}
   */
  replaceSelection: function replaceSelection(content, EditorSelectorID) {
    if (!content) {
      return;
    }

    var dom = document.getElementById(EditorSelectorID);
    dom.focus();
    var range;
    var node = typeof content === 'string' ? document.createTextNode(content) : content;

    if (window.getSelection) {
      var sel = window.getSelection();

      if (sel.getRangeAt && sel.rangeCount > 0) {
        range = sel.getRangeAt(0);
        range.deleteContents();
        range.collapse(false);
        range.insertNode(document.createTextNode(' '));
        range.insertNode(node);
        range.setStart(node, 0);
        setTimeout(function () {
          if (document.createRange) {
            range = document.createRange();
            range.setStartAfter(node);
            range.collapse(false);
            sel.removeAllRanges();
            sel.addRange(range);
          } else {
            var rangeObj = document.body.createTextRange();
            rangeObj.moveToElementText(node);
            rangeObj.select();
          }
        }, 0);
      } else {
        dom.innerHTML += node.outerHTML;
      }
    } else if (document.selection && document.selection.createRange) {
      range = document.selection.createRange();

      if (typeof content === 'string') {
        range.text = content;
      } else if (range.pasteHTML) {
        range.pasteHTML(content.outerHTML);
      } else {
        dom.innerHTML += node.outerHTML;
      }
    }
  }
};
/**
 * 操作 dom classNames (兼容不支持 classList 的浏览器)
 * @memberof module:dom
 * @property {function} filterRepeat -filterRepeat(arr) 数组去重
 * @property {function} addClass -addClass(elem,classStr) 添加className
 * @property {function} removeClass -removeClass(elem,classStr) 添删除lassName
 */

var classNameHandler = {
  // 数组去重
  filterRepeat: function filterRepeat() {
    var arr = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var dict = {};
    var rtn = [];
    arr.forEach(function (item) {
      if (!dict[item]) {
        dict[item] = 1;
        rtn.push(item);
      }
    });
    dict = null;
    return rtn;
  },
  // 添加一个 className
  addClass: function addClass(elem, classStr) {
    if (!elem) {
      return;
    }

    var array = this.filterRepeat(trim(elem.className).split(/\s+/));

    if (!array.includes(classStr)) {
      array.push(classStr);
    }

    elem.className = array.join(' ');
    return elem;
  },
  // 删除一个 className
  removeClass: function removeClass(elem, classStr) {
    if (!elem) {
      return;
    }

    var array = this.filterRepeat(trim(elem.className).split(/\s+/));
    var index = array.indexOf(classStr);

    if (index !== -1) {
      array.splice(index, 1);
      elem.className = array.join(' ');
    }

    return elem;
  }
};
/**
 * 检查元素是否可见
 * @memberof module:dom
 * @param {Object} DOM 元素
 * @return {bool}
 */

function isVisible(el) {
  var rect = el.getBoundingClientRect();
  var viewWidth = Math.max(document.documentElement.clientWidth, window.innerWidth);
  var viewHeight = Math.max(document.documentElement.clientHeight, window.innerHeight);
  return !(rect.bottom < 0 || rect.right > viewWidth + rect.width || rect.bottom > viewHeight + rect.height || rect.right < 0);
} // 监听页面 onload


function onLoad() {
  var callback = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function () {};

  if (document.readyState === 'complete') {
    callback();
  } else {
    addEvent(window, 'load', callback, false);
  }
}

function useIntervals(func, timeout) {
  setTimeout(function () {
    func();
    useIntervals(func, timeout);
  }, timeout);
}
/**
 * 侦测dom是否展示
 * @param param0 
 */


function detectDomIsVisible(_ref) {
  var getDomEvent = _ref.getDomEvent,
      callback = _ref.callback,
      _ref$options = _ref.options,
      options = _ref$options === void 0 ? {} : _ref$options;

  if (options.useInterval) {
    var _options$intervalOpti;

    // 使用 interval 刷新
    var timer = (options === null || options === void 0 ? void 0 : (_options$intervalOpti = options.intervalOptions) === null || _options$intervalOpti === void 0 ? void 0 : _options$intervalOpti.interval) || 200;
    useIntervals(function () {
      var doms = getDomEvent();
      doms.forEach(function (dom) {
        if (isVisible(dom)) {
          callback(dom);
        }
      });
    }, timer);
  } else {
    onLoad(function () {
      var doms = getDomEvent(); // 使用 intersectionObserver 或者 scroll event

      if (window.IntersectionObserver) {
        // 创建intersectionObserver
        var inter = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            var _options$intersection;

            var target = entry.target,
                intersectionRatio = entry.intersectionRatio;
            var threshold = (options === null || options === void 0 ? void 0 : (_options$intersection = options.intersectionObserverOptions) === null || _options$intersection === void 0 ? void 0 : _options$intersection.threshold) || 0.2;

            if (intersectionRatio < threshold) {
              return;
            }

            callback(target);
          });
        }, options.intersectionObserverOptions || {
          threshold: 0.2
        }); // watch dom

        doms.forEach(function (dom) {
          return inter.observe(dom);
        });
      } else {
        var scrollCheckVisibleEvt = throttle(function () {
          doms.forEach(function (dom) {
            if (isVisible(dom)) {
              callback(dom);
            }
          });
        }, 100);
        var parentDom = options.scrollEventOptions && options.scrollEventOptions.parentDom || window; // 使用scroll event

        addEvent(parentDom, 'scroll', scrollCheckVisibleEvt, false);
      }
    });
  }
} // helper for closest


function elementMatches(element, selector) {
  var elements = element.ownerDocument.querySelectorAll(selector);
  var index = 0;

  while (elements[index] && elements[index] !== element) {
    ++index;
  }

  return Boolean(elements[index]);
}
/**
 * @param {DOM} element
 * @param {string} selector 选择器
 * @memberof module:dom
 * @returns {null|DOM}
 */


function closest(element, selector) {
  while (element && element.nodeType === 1) {
    if (elementMatches(element, selector)) {
      return element;
    }

    element = element.parentElement;
  }

  return null;
}
/**
 * 保证元素可见
 * @param {DOM} elem DOM元素
 * @param {DOM} container 父container
 * @memberof module:dom
 */


function ensureVisible(elem, container) {
  // jquery offset原生实现
  function offset(target) {
    var top = 0;
    var left = 0;

    while (target.offsetParent) {
      top += target.offsetTop;
      left += target.offsetLeft;
      target = target.offsetParent;
    }

    return {
      top: top,
      left: left
    };
  } // elem = $(elem);
  // container = $(container);


  var top = offset(elem).top - offset(container).top;

  if (!top) {
    return;
  }

  if (top < 0) {
    container.scrollTop(container.scrollTop + top - 2);
    return;
  }

  top += elem.offsetHeight - container.offsetHeight;

  if (top > 0) {
    container.scrollTop = container.scrollTop + top + 2;
  }
}

var PIXEL_STEP = 10;
var LINE_HEIGHT = 40;
var PAGE_HEIGHT = 800;
/**
 * 计算鼠标滑动动，导致的页面滚动量
 * @memberof module:dom
 */

function normalizeWheel(event) {
  var sX = 0;
  var sY = 0; // spinX, spinY

  var pX = 0;
  var pY = 0; // pixelX, pixelY
  // Legacy

  if ('detail' in event) {
    sY = event.detail;
  }

  if ('wheelDelta' in event) {
    sY = -event.wheelDelta / 120;
  }

  if ('wheelDeltaY' in event) {
    sY = -event.wheelDeltaY / 120;
  }

  if ('wheelDeltaX' in event) {
    sX = -event.wheelDeltaX / 120;
  } // side scrolling on FF with DOMMouseScroll


  if ('axis' in event && event.axis === event.HORIZONTAL_AXIS) {
    sX = sY;
    sY = 0;
  }

  pX = sX * PIXEL_STEP;
  pY = sY * PIXEL_STEP;

  if ('deltaY' in event) {
    pY = event.deltaY;
  }

  if ('deltaX' in event) {
    pX = event.deltaX;
  }

  if ((pX || pY) && event.deltaMode) {
    if (event.deltaMode === 1) {
      // delta in LINE units
      pX *= LINE_HEIGHT;
      pY *= LINE_HEIGHT;
    } else {
      // delta in PAGE units
      pX *= PAGE_HEIGHT;
      pY *= PAGE_HEIGHT;
    }
  } // Fall-back if spin cannot be determined


  if (pX && !sX) {
    sX = pX < 1 ? -1 : 1;
  }

  if (pY && !sY) {
    sY = pY < 1 ? -1 : 1;
  }

  return {
    spinX: sX,
    spinY: sY,
    pixelX: pX,
    pixelY: pY
  };
}

export { selectionHandler, classNameHandler, isVisible, closest, ensureVisible, normalizeWheel, detectDomIsVisible };